import SiteLayout from '@/components/feature/SiteLayout';
import SeoHead from '@/components/feature/SeoHead';
import { homeFaqs } from '@/mocks/faqs';
import { liveSessions } from '@/mocks/lives';
import Hero from '@/pages/home/components/Hero';
import TodaySchedule from '@/pages/home/components/TodaySchedule';
import UpcomingSection from '@/pages/home/components/UpcomingSection';
import HotRankSection from '@/pages/home/components/HotRankSection';
import ReplaySection from '@/pages/home/components/ReplaySection';
import CategorySection from '@/pages/home/components/CategorySection';
import FaqSection from '@/pages/home/components/FaqSection';
import SubscribeSection from '@/pages/home/components/SubscribeSection';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        name: '爆料直播网',
        url: 'https://7kchain.cn/',
        inLanguage: 'zh-CN',
        description:
          '汇总今日直播排期、即将开始场次、直播回放列表与热门直播推荐，并提供直播预告提醒。',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://7kchain.cn/schedule?keyword={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'Organization',
        name: '爆料直播网',
        url: 'https://7kchain.cn/',
        email: 'contact@baoliaolive.com',
        description: '直播排期整理与呈现平台，覆盖娱乐、财经、电竞、好物、科技、体育、情感与音乐八个方向。',
      },
      {
        '@type': 'ItemList',
        name: '今日直播排期',
        itemListElement: liveSessions.map((session, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: session.title,
          url: `https://7kchain.cn/live/${session.id}`,
        })),
      },
      {
        '@type': 'FAQPage',
        mainEntity: homeFaqs.map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: { '@type': 'Answer', text: item.answer },
        })),
      },
    ],
  };

  return (
    <SiteLayout>
      <SeoHead
        title="爆料直播网 - 今日直播排期与即将开始场次、直播回放列表"
        description="想知道爆料直播今天播什么？爆料直播网汇总今日直播排期与即将开始场次，提供直播回放列表、热门直播推荐与直播预告提醒，帮你一眼看清并提前设好提醒。"
        keywords="爆料直播,今日直播排期,即将开始场次,直播回放列表,热门直播推荐,直播预告提醒"
        path="/"
        jsonLd={jsonLd}
      />
      <Hero />
      <TodaySchedule />
      <UpcomingSection />
      <HotRankSection />
      <ReplaySection />
      <CategorySection />
      <FaqSection />
      <SubscribeSection />
    </SiteLayout>
  );
}